import React, { useRef, useState } from 'react';
import enums from '../../../enums';
import '../styles.scss';

const MessageReceiversFilter = props => {
  let formRefrence = useRef();
  let [userFullNamePart, setUserFullNamePart] = useState('');
  let [userMobileNumberPart, setUserMobileNumberPart] = useState();

  const resetForm = event => {
    Array.from(formRefrence.current).forEach(element => {
      if (element.type === 'radio' || element.type === 'checkbox') {
        element.checked = null;
      } else if (element.name === 'resetButton') {
        element.value = locales('fields.reset');
      } else {
        element.value = null;
      }
    });
    setUserFullNamePart('');
    setUserMobileNumberPart('');
    props.applyFilters(event);
  };

  return (
    <article>
      <form
        ref={formRefrence}
        onReset={event => resetForm(event)}
        onSubmit={event => {
          props.applyFilters(event);
        }}
        id="filterForm"
        className="card card my-4"
      >
        <header className="text-center card-header">
          <h5 className="font-italic text-muted">{locales('titles.filter')}</h5>
        </header>
        <main className="card-body">
          <div className="d-flex justidy-content-start px-1">
            <div className="d-flex flex-column mx-1 col-4 h-50">
              <input
                onChange={event => setUserFullNamePart(event.target.value)}
                value={userFullNamePart || ''}
                name="userFullNamePart"
                type="text"
                className="form-control col-12"
                placeholder={locales('tables.fullName')}
                maxLength={enums.MAX_LENGTH.fullName}
              />
              <small style={{ color: '#ccc' }}>{locales('maxLength.50')}</small>
            </div>
            <div className="d-flex flex-column mx-1 col-4 h-50">
              <input
                onChange={event => setUserMobileNumberPart(event.target.value)}
                value={userMobileNumberPart || ''}
                name="userMobileNumberPart"
                type="text"
                className="form-control col-12"
                placeholder={locales('fields.mobileNumber')}
                maxLength={enums.MAX_LENGTH.mobileNumber}
              />
            </div>
          </div>
          <div className="col-12 d-flex justify-content-end p-0">
            <input
              name="resetButton"
              type="reset"
              value={locales('fields.reset')}
              className="btn btn-danger w-5 mx-2"
            />
            <button type="submit" id="apply-filter-btn-messageReceivers" className="btn btn-success w-5 mx-2">
              {locales('fields.applyFilters')}
            </button>
          </div>
        </main>
      </form>
    </article>
  );
};

export default MessageReceiversFilter;
